import {
    createContext, MutableRefObject,
} from 'react'
import {
    TableFilterParams,
} from 'app/types/common.types'

export type BatchActionData = TableFilterParams | boolean | null

export type TableActionsContextValue = {
    batchActionData: BatchActionData
    setBatchActionData: (data: BatchActionData) => void
    invalidateTableDataRef: MutableRefObject<() => void>
}

const TableActionsContext = createContext<TableActionsContextValue | undefined>(undefined)

export default TableActionsContext
